import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { useQuery } from "@tanstack/react-query";

export const getPromptbookTemplates = async (teamId?: string) => {
  const userId = await getUserId();
  const { data: templates, error } = await supabase.rpc("get_owned_resources", {
    p_principal_id: teamId || userId,
    p_type: "promptbook_template",
  });

  if (error) {
    throw new Error(error.message);
  }

  const { data: showcases } = await supabase.rpc("get_public_resources", {
    p_type: "promptbook_template",
  });

  if (!templates || !showcases) {
    return [];
  }

  const templatesWithShowcaseInfo = showcases.map((showcase) => {
    return {
      ...showcase,
      category: "default",
      isShowcase: true,
    };
  });

  return [...templates, ...templatesWithShowcaseInfo];
};

export const usePromptbookTemplates = (teamId?: string) => {
  return useQuery({
    queryKey: ["promptbook_templates", teamId],
    queryFn: () => getPromptbookTemplates(teamId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
